import { ImpactPartnerInfo } from '@platform/client/schemas';
import { Link } from 'wouter';
import { ROUTES } from '../routes/consts';
import { partnerLandingImages } from './partnerLandingContent';
import HeroArrowSvg from './svgs/hero-arrow.svg';
import MovingWorldLogo from './svgs/moving-world-logo.svg';

type PartnerLandingHeroProps = {
    partner: ImpactPartnerInfo;
};

export default function PartnerLandingHero({ partner }: PartnerLandingHeroProps) {
    const repSignUpPath = `${ROUTES.AUTH}${ROUTES.SIGN_UP}${ROUTES.SIGN_UP_REP}?impact=${partner.id}`;

    return (
        <main className="relative min-h-[calc(100vh-64px)] md:min-h-0 lg:min-h-[calc(100vh-64px)] bg-white flex flex-col lg:flex-row">

            {/* LEFT CONTENT */}
            <div className="flex flex-col justify-start px-8 pt-12 pb-12 lg:pt-16 lg:pb-24 lg:pl-16 xl:pl-24 lg:w-1/2 z-10">
                <div className="flex items-center gap-6 mb-6">
                    <div className="text-brand-500">
                        <img src={MovingWorldLogo} alt="MovingWorlds" className="max-h-[70px] w-auto object-contain" />
                    </div>

                    <div className="w-px h-[60px] bg-gray-100" />

                    {partner.logo ? (
                        <img
                            src={partner.logo}
                            alt={partner.name}
                            className="h-[120px] max-w-[220px] w-auto object-contain"
                        />
                    ) : (
                        <div className="text-gray-600 font-semibold text-xl">
                            {partner.name}
                        </div>
                    )}
                </div>

                <h1 className="text-gray-600 font-semibold text-4xl sm:text-5xl leading-tight tracking-tight mb-6 max-w-xl">
                    Personalized support to help grow your revenue and impact
                </h1>

                <p className="text-gray-500 text-lg leading-7 max-w-[500px] mb-10">
                    Available to social enterprises in the {partner.name} network at no cost,
                    through our partnership with MovingWorlds.
                </p>

                <div className="flex items-end w-full lg:w-auto">
                    <Link
                        to={`~platform${repSignUpPath}`}
                        className="bg-brand-500 text-white font-semibold text-lg leading-7 px-5 py-4 rounded-lg border border-brand-500 shadow-sm hover:bg-brand-600 transition-colors whitespace-nowrap w-full lg:w-auto text-center"
                    >
                        Get Started
                    </Link>
                </div>
            </div>

            {/* RIGHT IMAGE */}
            <div className="relative lg:w-1/2 h-72 sm:h-96 lg:h-auto overflow-hidden">
                <div className="absolute inset-0">
                    <img
                        src={partnerLandingImages.heroPrimary}
                        alt={`${partner.name} collaboration`}
                        className="w-full h-full object-cover object-[center_30%]"
                    />
                </div>
            </div>

            {/* ARROW (CENTERED BETWEEN SECTIONS) */}
            <div className="absolute left-[44%] top-[69%] -translate-x-1/2 pointer-events-none select-none hidden lg:block z-20">
                <img src={HeroArrowSvg} alt="" width={241} height={132} />
            </div>

        </main>
    );
}
